import { render, staticRenderFns } from "./TeamStatic.vue?vue&type=template&id=457927fa&scoped=true&"
import script from "./TeamStatic.vue?vue&type=script&lang=js&"
export * from "./TeamStatic.vue?vue&type=script&lang=js&"
import style0 from "./TeamStatic.vue?vue&type=style&index=0&id=457927fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457927fa",
  null
  
)

export default component.exports